import { render } from "./HomeVideo.vue?vue&type=template&id=4fbcadad&scoped=true"
import script from "./HomeVideo.vue?vue&type=script&lang=js"
export * from "./HomeVideo.vue?vue&type=script&lang=js"

import "./HomeVideo.vue?vue&type=style&index=0&id=4fbcadad&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\sthem\\source\\repos\\Insync\\Pamodzi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fbcadad"]])

export default __exports__